<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card footer-spacing">
          <!-- <div class="card-header">Dashboard</div> -->
          <!-- <div class="card-body"> -->
            <!-- <div v-if="user.loggedIn" class="alert alert-success" role="alert">You are logged in!</div> -->
            <!-- <div v-else class="alert alert-success" role="alert">You are not logged in!</div> -->
            <!-- if signed in then show survey, else show intro and login directions -->
            <div v-if="user.loggedIn">
              <ul>
                <li>
                <Section 
                  v-for="(section, index) in sections" 
                  :title="sections[index].title" 
                  :icon="sections[index].icon" 
                  :intro="sections[index].intro"
                  :sData="sections[index].data"
                  :sID="index"
                  :hidden="index === progress"
                  @nextSection="handleNextSection" 
                  :key="index">
                </Section>
                </li>
                <!-- <button v-on:click="debug(user.loggedIn)">Debug</button> -->
                <div
                v-if="progress >= sections.length"
                >
                <div class="card-header"><strong>Final Report</strong></div>
                  <div class="card-body">
                    <SWOT 
                      :sData="this.formatted.S" 
                      :wData="this.formatted.W" 
                      :oData="this.formatted.O" 
                      :tData="this.formatted.T" 
                      :sID="8"
                      id="Final"
                    />
                  </div>
                  <!-- <button v-on:click="CopyToClipboard()">Copy Report</button> -->
                  <span>Don't forget to copy and paste the report in a different document.</span>
                </div>
              </ul>
            </div>
            <div v-else class="card-body">
              <h1>Michigan Academy for Developing Entrepreneurs Marketing Assessment Tool</h1>
              <p>Welcome to the tool. This tool is designed to be filled out by you, the business owner, in cooperation with the organization you are partnered with. For each question, please answer as best you can. If the question is unclear, please ask the representative from the company you are working with to clarify. At the end of the assessment, you will have identified areas of strength for your business, areas of weakness, threats and opportunities for improvement. You and the company representative will use these results to craft the next steps for your business.</p>
              <p><strong>Sections</strong></p>
              <ol>
                <li>People</li>
                <li>Customers</li>
                <li>Product</li>
                <li>Place</li>
                <li>Price</li>
                <li>Promotion</li>
                <li>Competition</li>
                <li>Company</li>
              </ol>
              <div class="buttons">
                <button v-on:click="routePage('Login')">Login</button>
                <button v-on:click="routePage('Register')">Register</button>
              </div>
            </div>
          </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Section from './Section'
import SWOT from './SWOT';

export default {
    components: {
    // navbar
    // Question
    Section,
    SWOT
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user"
    })
  },
  methods: {
    handleNextSection(data) {
      // console.log("notified")
      data["S"].forEach(element => {
        this.formatted["S"].push(element);
      })
      data["W"].forEach(element => {
        this.formatted["W"].push(element);
      })
      data["O"].forEach(element => {
        this.formatted["O"].push(element);
      })
      data["T"].forEach(element => {
        this.formatted["T"].push(element);
      })
  console.log(this.formatted)
      this.progress += 1
    },
    routePage(url) {
      this.$router.replace({ name: url });
    },
    debug() {
      // console.log(data)
      let copyText = document.getElementById("Final")
      // copyText.textContent().select();
      // copyText.setSelectionRange(0, 99999);
      // document.execCommand("copy");
      console.log(copyText)

    }
    // CopyToClipboard() {
    //   let containerid = "Final";
    //   if (document.selection) {
    //     let range = document.body.createTextRange();
    //     range.moveToElementText(document.getElementById(containerid));
    //     range.select().createTextRange();
    //     document.execCommand("copy");
    //   } else if (window.getSelection) {
    //     let range = document.createRange();
    //     range.selectNode(document.getElementById(containerid));
    //     window.getSelection().addRange(range);
    //     document.execCommand("copy");
    //     alert("Text has been copied, now paste in the text-area")
    //   }
    // }
  },
  data: function() {
		return {
      progress: 0,
      formatted: {"S": [], "W": [], "O": [], "T": []},
      sections: [
        { 
          title: "People",
          icon: "people.svg",
          intro: "This section will evaluate how you interact with your primary customer base.",
          data: [
            {
              "type": "checkbox",
              "name": "Question 1",
              "label": "How do you primarily interact with your customers?",
              "options": {
                "S1": "Dedicated personal assistance",
                "O2": "Co-Creation",
                "S2": "Self-Service",
                "O1": "Automated services" }
            },
            {
              "type": "range",
              "name": "Question 2",
              "label": "What percentage of your customers are repeat customers?",
              "min": "0",
              "max": "100",
              "placeholder": "50",
              "showValue": "true",
              "validation": "required"
            },
            {
              "type": "select",
              "name": "Question 3",
              "label": "Do you have all the resources you need to communicate effectively through your desired people in order to reach your target customers?",
              "placeholder": "-",
              "options": {
                "": "-",
                "S1": "Yes",
                "W1": "No" },
              "validation": "required"
            }
          ]
        },
        {
          title: "Customers",
          icon: "customers.svg",
          intro: "This section will identify which part of the overall market your business primarily does business with.",
          data: [
            {
              "type": "checkbox",
              "name": "Question 4",
              "label": "How are you segmenting: demographics, psychographic, usage, or benefit sought?",
              "options": {
                "S1": "Demographics",
                "S2": "Psychographic",
                "S3": "Usage",
                "S4": "Benefit",
                "W1": "I do not know"}
            },
            {
              "type": "range",
              "name": "Question 5",
              "label": "What percentage of your sales are from your primary segment?",
              "min": "0",
              "max": "100",
              "placeholder": "50",
              "showValue": "true",
              "validation": "required"
            },
            {
              "type": "range",
              "name": "Question 6",
              "label": "What percentage of the market do you estimate your primary segment represents?",
              "min": "0",
              "max": "100",
              "placeholder": "50",
              "showValue": "true",
              "validation": "required"
            }
          ]
        },
        { 
          title: "Product",
          icon: "product.svg",
          intro: "This section assesses the value proposition you offer to your customers, whether in products or services delivered.",
          data: [
            {
              "type": "checkbox",
              "name": "Question 7",
              "label": "How is the product or service different from that of your competitors ",
              "options": {
                "T1": "Price",
                "S2": "Accessibility",
                "O1": "Innovative technology",
                "O2": "Is part of a growing industry"}
            },
            {
              "type": "select",
              "name": "Question 8",
              "label": "Do you keep track of how your customers find your product/service?",
              "options": {
                "": "-",
                "S1": "Yes",
                "W1": "No" },
              "validation": "required"
            },
            {
              "type": "checkbox",
              "name": "Question 9",
              "label": "How do you market your product or service? ",
              "options": {
                "W1": "Print Advertising",
                "S1": "Online Advertising",
                "O1": "Events",
                "S2": "Agency Consulting" }
            }
          ]
        },
        {
          title: "Place",
          icon: "place.svg",
          intro: "Place strategy outlines how and where a company will place its products and services in an attempt to gain market share and consumer purchases. Place marketing, including the emphasis on a place, its local attractions, traditions, business opportunities, can be defined as a marketing strategy to promote a particular place.",
          data: [
            {
              "type": "checkbox",
              "name": "Question 10",
              "label": "Do you intend to include the advantage of place marketing?",
              "options": {
                "S1": "I have included place advantages into my consideration of product development",
                "W1": "I do not think about places' advantages",
                "O1": "I am reaching out to my customers and knowing what they want to improve with the product in place",
                "T1": "I think my competitors are more aware of the place strategy than me"},
            },
            {
              "type": "select",
              "name": "Question 11",
              "label": "The customer journey is the cycle of interactions between customers and your business. Do you intentionally interact with your customers along any point of journey?",
              "options": {
                "": "-",
                "S1": "Yes",
                "W1": "No" }
            },
            {
              "type": "checkbox",
              "name": "Question 12",
              "label": "Which portion of the journey do you focus on?",
              "options": {
                "S1": "Awareness",
                "S2": "Evaluation",
                "S3": "Purchase",
                "S4": "Delivery",
                "S5": "After Sales"}
            },
            {
              "type": "checkbox",
              "name": "Question 13",
              "label": "What channels do you use to interact with the customer on their journey?",
              "options": {
                "S1": "Advertising",
                "S2": "Promotions",
                "S3": "Mix of both",
                "S4": "Other"}
            }
          ]
        },
        { 
          title: "Price",
          icon: "price.svg",
          intro: "This section assesses how you've set your prices and how you compare to your competition.",
          data: [
            {
              "type": "checkbox", 
              "name": "Question 14",
              "label": "Revenue is a function of how many units of a good or service you sell at a particular price point. Thinking about your prices, please check all that apply",
              "options": {
                "S1": "I feel comfortable with the price points I have set for my product/service",
                "O1": "I would like assistance evaluating the price points I have set for my product/service",
                "W1": "I do not know how my prices compare with my competitors",
                "T1": "I often have to lower my prices in order to compete with other companies",
                "O2": "My customers are willing to pay a higher price for my product/service than for my competitors’, but I have fewer customers overall"}          
            },
            {
              "type": "checkbox",
              "name": "Question 15",
              "label": "There are many pricing strategies that can increase your return. Please indicate your comfort level with pricing strategy.",
              "options": {
                "S1": "I have successfully run a price experiment in the past",
                "W1": "I do not know how to set up a price experiment",
                "O1": "I need help understanding how a price experiment could help my business"}
            }
          ]
        },
        {
          title: "Promotion",
          icon: "promotion.svg",
          intro: "This section assesses your current promotional efforts.",
          data: [
            {
              "type": "checkbox",
              "name": "Question 16",
              "label": "Promotion of your company can be through paid, earned, or owned media. An example of paid media is paying a newspaper to run an ad for you. Earned media is attention you get from your customers through social media platforms or  word of mouth. Owned media is something you own that brings customers to you, such as a blog you run or salespeople who generate leads for you. Please mark what applies to your business.",
              "options": {
                "S1": "I use a combination of several types of promotional media",
                "T1": "I do not know how to measure the returns I get on the promotional dollars I spend",
                "S2": "I am comfortable calculating my returns on money I spend on promotional media",
                "O1": "I want to learn to calculate returns",
                "O2": "I do not understand how paid, earned, and owned media apply to my company"}
            },
            {
              "type": "textarea",
              "name": "Question 17",
              "label": "What is the promotional area you are most interested in getting expert advice in?",
            },
            {
              "type": "textarea",
              "name": "Question 18",
              "label": "What do you want to accomplish in your next marketing campaign?",
            }
          ]
        },
        { 
          title: "Competition",
          icon: "competition.svg",
          intro: "This section looks at your current competitors and how you differentiate your self from them",
          data: [
            {
              "type": "checkbox",
              "name": "Question 19",
              "label": "Market share is the percent of the total number of customers who have either already or may potentially make a purchase. Thinking about your company, please check what applies to you.",
              "options": {
                "S1": "I have a good understanding of the market in my area",
                "O1": "I would like help understanding the market in my area",
                "T1": "I think my percent of the market share has been falling",
                "O2": "I would like help assessing whether expanding into a new market is a good idea"}
            },
            {
              "type": "checkbox",
              "name": "Question 20",
              "label": "Companies compete on quality, value, service level, and/or brand popularity. Thinking about how your company compares to others, please check all that apply.",
              "options": {
                "T1": "I offer the same product or service as my competitors and directly compete on value, quality, service, or brand",
                "S1": "I have superiority in at least one element (brand, value, service, quality), and my customers are aware of what sets us apart",
                "O1": "I need help building customer awareness of how my product/service is superior to my competitors",
                "W1": "I am not sure which domain to emphasize to my customers"}
            }
          ]
        },
        {
          title: "Company",
          icon: "company.svg",
          intro: "This section assesses your overall company branding and marketing strategy.",
          data: [
            {
              "type": "select",
              "name": "Question 21",
              "label": "Branding helps customers associate your company with the unique value proposition you offer. Please check all that apply.",
              "options": {
                "": "-",
                "W1": "I do not have a comprehensive brand strategy",
                "S1": "My branding is consistent throughout all customer touchpoints (website, social media, business cards, storefront, etc)"},
              "validation": "required"
            },
            {
              "type": "checkbox",
              "name": "Question 22",
              "label": "Marketing is a broad business function but is vital to your business' success. Think about your existing marketing strategy and check all that apply.",
              "options": {
                "S1": "Either I or my marketing team are in a good position. I do not have concerns about my marketing strategy",
                "T1": "I do not have any kind of marketing program for my company",
                "W1": "I need help understanding where to start with my marketing strategy",
                "O2": "I know the specific marketing area I want help with"}
            }
          ]
        }
      ]
      
    }
  }
};
</script>

<style>
  ul {
    padding: 0 !important;
    margin: 0 !important;
    list-style: none;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content:  center;
    margin-top: 5vh;
  }

  button {
    margin: 0 auto;
  }

  .footer-spacing {
    margin-bottom: 10vh;
  }
</style>